import type { EmojiText } from '@/services/forms/types'
import type { FilteredViewSharingType } from '@/services/domain/filteredViews/types'
import type { PaginationUrlFilterType, PaginationUrlParametersSortType } from '@/services/tables/types'
import type { ApiColumn } from '@/core/tables/types'

export enum TicketViewsFormFields {
  id = 'id',
  filters = 'filters',
  columns = 'columns',
  sorting = 'sorting',
  name = 'name',
  sharingType = 'sharingType',
}

export type FilteredViewsFormSchema = {
  [TicketViewsFormFields.id]: string
  [TicketViewsFormFields.filters]: PaginationUrlFilterType
  [TicketViewsFormFields.columns]: ApiColumn[]
  [TicketViewsFormFields.sorting]: null | PaginationUrlParametersSortType
  [TicketViewsFormFields.name]: Required<EmojiText>
  [TicketViewsFormFields.sharingType]: FilteredViewSharingType
}
